import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'lilu-cms-text-col',
  styleUrl: 'lilu-cms-text-col.scss',
  shadow: true,
})
export class LiluCmsTextCol {
  @Prop() background: string;

  render() {
    return (
      <Host>
        <div class={`text`}>
          <div class="headline">
            <slot name="headline"></slot>
          </div>
          <div class="text-col">
            <slot name="left"></slot>
            <slot name="middle"></slot>
            <slot name="right"></slot>
          </div>
          <div class="links">
            <slot name="link"></slot>
          </div>
        </div>
      </Host>
    );
  }
}
